// extracted by mini-css-extract-plugin
module.exports = {"textSlot":"DropdownMenu-module__textSlot___cEFA+","items":"DropdownMenu-module__items___i6iDk","divider":"DropdownMenu-module__divider___zkUgV"};